// extracted by mini-css-extract-plugin
module.exports = {"groupRenameInputInModal":"_groupRenameInputInModal--2fq6U","confirmDialog":"_confirmDialog--1lYDp","renameGroupHelperText":"_renameGroupHelperText--2IeEd"};